import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["LandingStory"] */ "/vercel/path0/src/components/piai/marketing/LandingStory.tsx");
